import * as z from 'zod/v4'

import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {FormSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/form'
import {PrimerComponentCardSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentCard'
import {PrimerComponentProseSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentProse'
import {PrimerComponentHeroSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentHero'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {GenericCallToActionSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/genericCallToAction'
import {PersonSchema} from './person'

// smaller version to support caching in BE
// see https://github.com/github/marketing-platform-services/issues/3261
export const TemplateResourceDetailsTruncatedSchema = buildEntrySchemaFor('templateResourceDetails', {
  fields: z.lazy(() =>
    z.object({
      heading: z.string(),
      contentType: z.string(),
      featuredImage: AssetSchema.optional(),
      excerpt: RichTextSchema.optional(),
    }),
  ),
})

export type ResourceDetailsTruncated = z.infer<typeof TemplateResourceDetailsTruncatedSchema>

export const TemplateResourceDetailsSchema = buildEntrySchemaFor('templateResourceDetails', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      hero: PrimerComponentHeroSchema.optional(),
      featuredImage: AssetSchema.optional(),
      lede: RichTextSchema.optional(),
      excerpt: RichTextSchema.optional(),
      body: PrimerComponentProseSchema.optional(),
      tableOfContents: z.boolean().optional(),
      featuredCta: GenericCallToActionSchema.optional(),
      form: FormSchema.optional(),
      peopleLabel: z.string().optional(),
      people: z.array(PersonSchema).optional(),
      topics: z.array(z.string()).optional(),
      relatedResources: z.array(PrimerComponentCardSchema).optional(),
    }),
  ),
})

export type ResourceDetailsPage = z.infer<typeof TemplateResourceDetailsSchema>
